<template>
  <a-layout id="components-layout-demo-custom-trigger">
    <!-- 左侧菜单 -->
    <a-layout-sider
      :trigger="null"
      collapsible
      v-model="collapsed"
      style="min-height:100vh;"
    >
      <div class="logo">
        <!-- <img src="../assets/logo_small.png" width="120" style="margin-left:8px;" /> -->
        E滁州案例集管理系统
      </div>
      <a-menu
        :defaultSelectedKeys="$route.meta.key"
        :defaultOpenKeys="$route.meta.sub"
        :selectedKeys="$route.meta.key"
        mode="inline"
        theme="dark"
        :inlineCollapsed="collapsed"
      >
        <a-sub-menu key="article" v-if="permissionsIfShow('article')">
          <span slot="title">
            <a-icon type="file-word" />
            <span>案例集管理</span>
          </span>
          <a-menu-item key="article-category">
            <router-link to="/article/category">一级分类</router-link>
          </a-menu-item>
          <a-menu-item key="article-subcategory">
            <router-link to="/article/subcategory">二级分类</router-link>
          </a-menu-item>
          <a-menu-item key="article">
            <router-link to="/article/list">案例列表</router-link>
          </a-menu-item>
          <a-menu-item key="article-banner">
            <router-link to="/article/banner">banner列表</router-link>
          </a-menu-item>
          <a-menu-item key="article-contact">
            <router-link to="/article/contact">联系我们</router-link>
          </a-menu-item>
        </a-sub-menu>

        <a-sub-menu key="qiniu" v-if="permissionsIfShow('qiniu')">
          <span slot="title">
            <a-icon type="cloud-upload" />
            <span>七牛管理</span>
          </span>
          <a-menu-item key="qiniu-list">
            <router-link to="/qiniu/list">上传记录</router-link>
          </a-menu-item>
        </a-sub-menu>

        <a-sub-menu key="admin" v-if="permissionsIfShow('admin')">
          <span slot="title">
            <a-icon type="setting" />
            <span>后台管理</span>
          </span>
          <a-menu-item key="admin-group">
            <router-link to="/user/permission">管理组列表</router-link>
          </a-menu-item>
          <a-menu-item key="admin-manager">
            <router-link to="/user/list">管理员列表</router-link>
          </a-menu-item>
        </a-sub-menu>
      </a-menu>
    </a-layout-sider>

    <a-layout>
      <!-- 头部菜单 -->
      <a-layout-header id="header-lr" style="background: #fff; padding: 0;">
        <div>
          <a-icon
            class="trigger"
            :type="collapsed ? 'menu-unfold' : 'menu-fold'"
            @click="() => (collapsed = !collapsed)"
          />
        </div>
        <div id="header-menus">
          <!-- 用户操作 -->
          <a-dropdown :trigger="['click']">
            <div class="ant-dropdown-link" style="cursor:pointer;">
              <img
                v-if="$store.getters.getUser && $store.getters.getUser.avatar"
                :src="
                  $store.getters.getUser ? $store.getters.getUser.avatar : ''
                "
                style="width:24px; height:24px; border-radius:24px;"
              />
              <img
                v-if="$store.getters.getUser && $store.getters.getUser.photo"
                :src="
                  $store.getters.getUser
                    ? qiniuURL + $store.getters.getUser.photo.fields.url
                    : ''
                "
                style="width:24px; height:24px; border-radius:24px;"
              />
              <a-avatar v-else :size="24" icon="user" />
              <span style="margin-left:8px;">
                {{
                  $store.getters.getUser
                    ? $store.getters.getUser.fields.username
                    : ""
                }}
              </span>
              <span style="margin-left:8px;">
                {{
                  $store.getters.getUser && $store.getters.getUser.group
                    ? $store.getters.getUser.group.fields.name
                    : ""
                }}
              </span>
            </div>
            <a-menu slot="overlay">
              <a-menu-item key="1">
                <a @click="modalStatus_1">修改密码</a>
              </a-menu-item>
              <a-menu-divider />
              <a-menu-item key="3" @click="userLogOut">退出</a-menu-item>
            </a-menu>
          </a-dropdown>
        </div>
      </a-layout-header>

      <!-- 右侧主区域 -->
      <a-layout-content
        style="margin: 0px; padding: 0px; padding-bottom:60px; background: #fff; minHeight: 280px; "
      >
        <a-breadcrumb>
          <a-breadcrumb-item
            v-for="(item, index) in $route.meta.title"
            :key="index"
            >{{ item }}</a-breadcrumb-item
          >
        </a-breadcrumb>

        <router-view />
      </a-layout-content>
    </a-layout>

    <!-- 弹出层 -->
    <a-modal
      title="修改密码"
      :visible="modalVisible_1"
      @ok="modalSubmit_1"
      :confirmLoading="modalLoading_1"
      @cancel="modalStatus_1"
    >
      <div style="margin-left:53px; margin-bottom:10px; color:#000;">
        用户名：{{ modalName_1.fields && modalName_1.fields.username }}
      </div>
      <a-form :form="form1">
        <a-form-item
          style="display:none;"
          label="用户名id"
          :label-col="{ span: 5 }"
          :wrapper-col="{ span: 12 }"
        >
          <a-input v-decorator="['id', { initialValue: modalName_1.pk }]" />
        </a-form-item>
        <a-form-item
          label="当前密码"
          :label-col="{ span: 5 }"
          :wrapper-col="{ span: 12 }"
        >
          <a-input
            type="password"
            v-decorator="[
              'oldPassword',
              { rules: [{ required: true, message: '当前密码未填写' }] }
            ]"
          />
        </a-form-item>
        <a-form-item
          label="新密码"
          :label-col="{ span: 5 }"
          :wrapper-col="{ span: 12 }"
        >
          <a-input
            type="password"
            v-decorator="[
              'newPassword',
              { rules: [{ required: true, message: '新密码未填写' }] }
            ]"
          />
        </a-form-item>
      </a-form>
    </a-modal>
  </a-layout>
</template>

<script>
export default {
  data() {
    return {
      collapsed: false,
      // 弹出层
      modalLoading_1: false,
      modalVisible_1: false,
      modalName_1: "",
      form1: this.$form.createForm(this, { name: "modalForm_1" }),

      // 通知：
      limit: 5,
      list: [],
      total: 0,
      down: true,
      noticeLoding: false,

      // 活动
      activity_list: []
    };
  },
  watch: {
    $route(to, from) {
      console.log("跳转从：", from, " 至 ", to);
      this.permission();
    }
  },
  created() {
    this.getActivity();
    this.isOnline();
    this.getManagerInfo();
  },
  methods: {
    isOnline() {
      this.api.isOnline({}, res => {
        if (res.success) {
          console.log("在线，允许访问");
        }
      });
    },
    permission() {
      console.log(this.$route.params);
      console.log(`${this.$route.meta.permission}_${this.$route.params[0]}`);
      console.log(this.$route.meta.permission);
      console.log(this.$store.getters.getUser.permissions);
      if (this.$route.meta.permission === "") {
        console.log("允许访问");
      } else if (
        this.$store.getters.getUser &&
        this.$route.meta.permission &&
        this.$store.getters.getUser.permissions &&
        this.$store.getters.getUser.permissions.indexOf(
          this.$route.params.activity_id
            ? `${this.$route.meta.permission}_${this.$route.params.activity_id}`
            : this.$route.meta.permission
        ) > -1
      ) {
        console.log("允许访问");
      } else {
        this.$router.push({
          path: "/permission/404"
        });
      }
    },
    getManagerInfo() {
      this.api.getManagerInfo({}, res => {
        if (res.success) {
          let permissions = [];
          for (let i = 0; i < res.data.permissions.length; i++) {
            permissions.push(res.data.permissions[i].fields.name);
          }
          console.log(permissions);
          res.data.user["permissions"] = permissions;
          res.data.user["photo"] = res.data.photo;
          res.data.user["group"] = res.data.group;
          this.$store.dispatch("setToken", res.data.user.fields.accessToken);
          this.$store.dispatch("setUser", res.data.user);

          this.permission();
        }
      });
    },
    getActivity() {
      // this.api.getActivityList({}, res => {
      //   if (res.success) {
      //     console.log(res.data.list);
      //     this.activity_list = res.data.list;
      //   } else {
      //     this.$notification.error({
      //       message: "错误警告！",
      //       description: res.message
      //     });
      //   }
      // });
    },
    permissionsIfShow(value) {
      if (
        this.$store.getters.getUser &&
        this.$store.getters.getUser.permissions &&
        this.$store.getters.getUser.permissions.indexOf(value) > -1
      ) {
        return true;
      }
      return false;
    },
    // 退出登录
    userLogOut() {
      this.api.logout({}, res => {
        if (res.success) {
          this.$store.dispatch("setToken", "");
          localStorage.setItem("token", "");

          this.$store.dispatch("setUser", null);
          localStorage.setItem("user", null);

          this.$router.push({
            path: "/login"
          });
        } else {
          this.$notification.error({
            message: "错误警告！",
            description: res.message
          });
        }
      });
    },

    // 修改密码
    modalStatus_1() {
      this.form1.resetFields();
      this.modalVisible_1 = !this.modalVisible_1;
      this.modalName_1 = this.$store.getters.getUser;
    },
    modalSubmit_1() {
      this.form1.validateFields((err, values) => {
        this.modalLoading_1 = true;
        if (err) {
          this.modalLoading_1 = false;
          return;
        }

        if (values.newPassword === values.currentPassword) {
          this.modalLoading_1 = false;
          this.$notification.error({
            key: "same",
            message: "错误警告！",
            description: "新密码不可与当前密码相同"
          });
          return;
        }

        this.api.updatePassword(values, res => {
          this.modalLoading_1 = false;
          if (res.success) {
            this.form1.resetFields();
            this.modalVisible_1 = false;
          } else {
            this.$notification.error({
              key: "edit-pwd",
              message: "错误警告！",
              description: res.message
            });
          }
        });
      });
    }
  }
};
</script>

<style>
#components-layout-demo-custom-trigger .trigger {
  font-size: 18px;
  line-height: 64px;
  padding: 0 24px;
  cursor: pointer;
  transition: color 0.3s;
}

#components-layout-demo-custom-trigger .trigger:hover {
  color: #1890ff;
}

#components-layout-demo-custom-trigger .logo {
  height: 32px;
  margin: 16px;
  overflow: hidden;
  line-height: 32px;
  color: #fff;
  font-size: 20px;
}
#header-lr {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  webkit-box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  z-index: 105;
  height: 40px;
}
#header-menus {
  margin-right: 20px;
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: center;
}
.ant-breadcrumb {
  height: 40px;
  line-height: 40px;
  webkit-box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  z-index: 106;
  padding: 0px 24px;
  font-size: 14px;
  overflow: hidden;
}
.ant-breadcrumb > span:last-child {
  color: #1890ff;
}
#content-main {
  padding: 18px;
  padding-bottom: 100px;
}
#content-main-mobile {
}
.flex-center {
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
}
.flex-start {
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: center;
}
.flex-wrap-start {
  display: flex;
  flex-flow: row wrap;
  justify-content: flex-start;
  align-items: center;
}
.flex-between {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
}
.flex-between-start {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: flex-start;
}
.flex-wrap-between {
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  align-items: center;
}
.text-primary {
  color: #04387b;
}

.ft12 {
  font-size: 12px;
}

.ft14 {
  font-size: 14px;
}

.ft16 {
  font-size: 16px;
}

.ft18 {
  font-size: 18px;
}

.ft20 {
  font-size: 20px;
}
.ant-form-item {
  margin-bottom: 10px;
}

a {
  color: #04387b;
}

.text-bold {
  font-weight: bold;
}

.text-gray {
  color: #999;
}

.ant-modal-title {
  color: #04387b;
}

.notice-item {
  padding-bottom: 10px;
  border-bottom: #e8e8e8 solid 1px;
  margin-top: 10px;
}
</style>
